import message from 'antd/lib/message';
import 'core-js/features/string/replace-all';
import { IUserInfo } from 'src/lib/types/user-info';

export interface IFormatTranslationProp {
  text: string;
  translations: Array<{
    key: string;
    value: string | number;
  }>;
}

export function failedToast(text) {
  message.error(text);
}

// for replacing the params if the translator sets params in Weblate
export function replaceI18nParam(text, paramName, paramValue) {
  return text?.replace(paramName, paramValue);
}

export function getQueryParams() {
  if (process.browser) {
    const { search } = window.location;
    if (!search) return {};
    return search
      .slice(1)
      .split('&')
      .reduce((prev, cur) => {
        const [key, value] = cur.split('=');
        return { ...prev, [key]: decodeURIComponent(value) };
      }, {});
  }
}

export const getDisplayUserName = (userInfo: IUserInfo) => {
  if (userInfo?.username) {
    return userInfo?.username;
  } else if (userInfo?.vague_email) {
    // abcde@gmail.com -> abc***@gmail.com
    const emailArr = userInfo?.vague_email.split('@');

    const firstPart = emailArr[0]?.substring(0, 3) || '';
    const secondPart = emailArr[1] || '';
    return `${firstPart}***@${secondPart}`;
  } else if (userInfo?.vague_mobile) {
    // 12345678 -> 123*****
    const firstPart = userInfo?.vague_mobile.toString().substring(0, 3);
    return `${firstPart}*****`;
  }

  return '';
};

export const formatTranslation = ({
  text = '',
  translations = [],
}: IFormatTranslationProp) => {
  let formattedText = text;
  for (let i = 0; i < translations.length; i++) {
    const { key, value } = translations[i];
    formattedText = formattedText.replaceAll(`{{${key}}}`, value?.toString());
  }

  return formattedText;
};
